module.exports = __webpack_public_path__ + "img/site_type_img_13.e69ac8b6.png";